import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';

import SpecificComponent from '../SpecificComponent'
import { Fab, FormControl, InputLabel, Select, MenuItem, Input, Grid } from '@material-ui/core';
import Utils from '../../providers/Utils';
import PropTypes from 'prop-types';


export default class EtapeProjectAdd extends SpecificComponent {

    constructor(props) {
        super(props)
        this.state = {
            nume: '',
            dela: new Utils().defaultData(),
            panala: new Utils().defaultDataPlus7Days(),
        }
    }

    handleChange = nume => ev => {
        this.setState({
            [nume]: ev.target.value
        })
    }

    onAdd = () => {
        let objToSend = {
            nume: this.state.nume,
            dela: this.state.dela,
            panala: this.state.panala
        }
        if (this.state.nume.length > 2) {
            this.props.handleAdd(objToSend)
        }
    }

    render() {
        return (
            <Dialog
                open={this.props.open}
                onClose={this.props.handleClose}
            >

                <DialogActions>
                    <Fab onClick={this.props.handleClose} className="pm-round-button-dialog">
                        <i className='material-icons pm-round-button-text-dialog'>clear</i>
                    </Fab>
                </DialogActions>
                <DialogTitle  >{this.props.title}</DialogTitle>

                <DialogContent>
                    <Grid container >
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >


                            <TextField
                                label={this.props.dict.proiecte.etapeProiect.denumire}
                                value={this.state.nume}
                                onChange={this.handleChange('nume')}
                                margin="normal"
                            />
                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >

                            <FormControl className='inputFocus' style={{ width: '90%' }}>
                                <InputLabel htmlFor="resursa">{this.props.dict.proiecte.etapeProiect.responsabil}</InputLabel>
                                <Select

                                    value={this.props.responsabil || ""}
                                    onChange={this.props.responsabilChange}

                                    input={<Input id="resursa" />}>


                                    {this.props.responasbili.map((s, idx) => {
                                        return <MenuItem value={s.id} key={idx}  > {s.nume}</MenuItem>

                                    })
                                    }
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <TextField
                                label={this.props.dict.proiecte.etapeProiect.dela}
                                value={this.state.dela}
                                onChange={this.handleChange('dela')}
                                margin="normal"
                                type='date'
                            />

                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <TextField
                                label={this.props.dict.proiecte.etapeProiect.panala}
                                value={this.state.panala}
                                onChange={this.handleChange('panala')}
                                margin="normal"
                                type='date'
                            />

                        </Grid>
                    </Grid>

                </DialogContent>

                <DialogActions>


                    <Button onClick={this.onAdd} style={{ color: this.theme.addColor1 }} >
                        {this.dictionary.comune.add}
                    </Button>
                </DialogActions>

            </Dialog>
        );
    }


}  // end class

EtapeProjectAdd.propType = {
    open: PropTypes.bool,
    handleClose: PropTypes.func,
    handleAdd: PropTypes.func,
    title: PropTypes.string,
    dict: PropTypes.object,
    responasbili: PropTypes.array,
    responsabil: PropTypes.number,
    responsabilChange: PropTypes.func
}